$(document).ready(function() {
  window.addEventListener("resize", headerUpdate);
  window.addEventListener("load", headerUpdate);
})

function headerUpdate() {
  // show the header dropdown on hover
  if ($( window ).width() > 1020) {
    $("#Details-HeaderMenu-2").on( "mouseenter", function()  {
      $(this).attr('open', 'open');
      $(this).find('summary').attr('aria-expanded', true)
    });

    $("#Details-HeaderMenu-2").on( "mouseleave", function()  {
      $(this).removeAttr('open');
      $(this).find('summary').attr('aria-expanded', false)
    });
  }

  // use accordion on footer list
  if($( window ).width() < 750) {
    let accordion = document.getElementsByClassName("footer-block--menu");


    for (i = 0; i < accordion.length; i++) {
        accordion[i].addEventListener("click", function() {
            this.classList.toggle("active");

            var openAccordion = this.children[1];
            if (openAccordion.style.maxHeight) {
              openAccordion.style.maxHeight = null;
            } else {
              openAccordion.style.maxHeight = openAccordion.scrollHeight + "px";
            } 

        });
    }
  }
}